<template>
  <div
    class="cut-card-tracking"
    qa="cut-card-tracking"
  >
    <b-row
      class="single-card py-2 mb-3"
      :class="stateClass"
    >
      <b-col>
        <b-row>
          <b-col @click="selectRow()">
            <b-row>
              <!--Check-->
              <b-col
                cols="auto"
                class="d-flex align-items-center"
                :class="{'selectable': selectable}"
              >
                <div
                  class="tr-btn d-flex align-items-center justify-content-center"
                  :class="{'active': selectable, 'checked': checked}"
                >
                  <i
                    v-show="checked"
                    class="fal fa-check"
                    aria-hidden="true"
                  />
                </div>
              </b-col>
              <!--Main-->
              <b-col
                cols="3"
                class="main-info d-flex pl-2"
                :class="{'selectable': selectable}"
              >
                <div
                  style="width: 40px"
                  class="d-flex align-items-center justify-content-center"
                >
                  <img
                    src="@/img/porta-tr.png"
                    alt="porta-icon"
                  >
                </div>
                <div class="text-section d-flex flex-column justify-content-center ml-3">
                  <span
                    class="card-label primary-dark-color font-weight--medium"
                    qa="cut-card-tracking-label"
                  >{{ information.supLabel }}</span>
                  <span
                    class="card-text"
                    qa="cut-card-tracking-topographic-code"
                  >{{ information.portion.sample.topographicCode.description }}</span>
                </div>
              </b-col>
              <b-col
                cols="4"
                class="main-info d-flex pl-2"
                :class="{'selectable': selectable}"
              >
                <div class="text-section d-flex flex-column ml-3">
                  <span
                    class="card-label primary-dark-color"
                    qa="cut-card-tracking-assay-name"
                  >{{ information.assay.name }}</span>
                  <span
                    class="card-text"
                    :class="{'empty-text': !information.taskDevice}"
                    qa="cut-card-tracking-device"
                  >{{ information.taskDevice ? information.taskDevice.device : '' }}</span>
                </div>
              </b-col>
              <b-col>
                <small>{{ $t('laboratory.tracking.requestDate') }}</small>
                <h4
                  class="collapsable-card-title inside"
                  qa="cut-card-tracking-request-date"
                >
                  {{ information.supRequestDate | date }}
                </h4>
              </b-col>
              <b-col class="d-flex align-items-center justify-content-end pl-2">
                <div
                  class="external-control-icons"
                >
                  <!-- TODO: Next icons are prepared for external control development -->
                  <span
                    v-if="false"
                    v-tooltip.html="`${$tc('global.externalControlRequired')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
                    class="icon-control-required mx-2 alt-color"
                    qa="cut-card-tracking-external-control-required"
                  />
                  <span
                    v-if="false"
                    v-tooltip="$tc('global.noExternalControl')"
                    class="icon-control-slash mr-1 alt-color"
                    qa="cut-card-tracking-no-external-control"
                  />
                  <span
                    v-if="false"
                    v-tooltip.html="`${$tc('global.externalControlOptional')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
                    class="icon-control-optional-true mr-1 alt-color"
                    qa="cut-card-tracking-external-control-optional-true"
                  />
                  <span
                    v-if="false"
                    v-tooltip.html="`${$tc('global.externalControlOptional')} ${$tc('global.externalControlUnmarked')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
                    class="icon-control-optional-false mr-1 alt-color"
                    qa="cut-card-tracking-external-control-optional-false"
                  />
                  <span
                    v-if="false"
                    v-tooltip.html="`${$tc('global.externalControlOnDemand')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
                    class="icon-control-on-demand-true mr-1 alt-color"
                    qa="cut-card-tracking-external-control-on-demand-true"
                  />
                  <span
                    v-if="false"
                    v-tooltip.html="`${$tc('global.externalControlOnDemand')} ${$tc('global.externalControlUnmarked')}:<br>${$tc('configuration.grid.controlTypeTissueControl')}`"
                    class="icon-control-on-demand-false mr-1 alt-color"
                    qa="cut-card-tracking-external-control-on-demand-false"
                  />
                </div>
                <div
                  v-if="information.requester"
                  class="profile-img mr-2"
                >
                  <vt-personnel-profile-image
                    :personnel-id="information.requester.id"
                    :img-tooltip="`${$tc('global.petitioner')}<br/>${information.requester.fullName}`"
                    img-class="img-fluid"
                    qa="cut-card-tracking-petitioner-profile-image"
                  />
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ASSAY_STATES } from '@/api/resources/entityState/assay-state'

export default {
    name: 'CutCardTracking',
    props: {
        information: { type: Object, required: true }
    },
    data() {
        return {
            checked: this.isPending()
        }
    },
    computed: {
        stateClass() {
            return {
                process: this.information.assayStatus.code === ASSAY_STATES.IN_PROCESS.code,
                cancel: this.information.assayStatus.code === ASSAY_STATES.CANCELED.code,
                finished: this.information.assayStatus.code === ASSAY_STATES.FINISHED.code,
                pending: this.isPending()
            }
        },
        selectable() {
            return this.isPending()
        }
    },
    methods: {
        isPending() {
            return this.information.assayStatus.code === ASSAY_STATES.PENDING.code
        },
        selectRow() {
            if (this.selectable) {
                this.checked = !this.checked
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.cut-card-tracking {
    .single-card {
        background: #FFF;
        box-shadow: 2px 2px 3px 0 #9c9c9c;
        border: 1px solid #d8d8d8;
        border-left: 13px solid;
        border-radius: 1rem;

        &.finished {
            border-color: state-color(state-success);
        }

        &.pending {
            border-color: state-color(state-pending);
        }

        &.cancel {
            border-color: state-color(state-canceled);
        }

        &.process {
            border-color: state-color(state-process-1);
        }

        .card-text {
            margin-top: 0;
        }

        .tr-btn {
            width: 35px;
            height: 35px;
            background: #FFF;

            &.active{
                border: 1px solid #d8d8d8;
                border-radius: 50%;
                color: grey;
            }

            &.checked{
                background: #2ecc71;
                color: #FFF;
            }
        }

        .main-info {
            img {
                width: 35px;
            }

            small{
                font-size: 11px;
            }

            .flex-column {
                line-height: 17px;
            }

            .text-section {
                margin-top: 5px;
            }
        }

        .selectable {
            cursor: pointer;
        }

        h4 {
            font-weight: normal;
            font-size: .9rem;
        }

        .buttons {
            font-size: 20px;
            color: #2ecc71;
        }

        .info-icon {
            font-size: 20px;
        }

        .block-icon {
            width: 25px !important;
        }
    }
}

</style>
